export default "__VITE_ASSET__B8w6xtwn__"